// extracted by mini-css-extract-plugin
export default {"ProfileCard":"styles_ProfileCard__hBBmF","InfoText":"styles_InfoText__nAezn","Table":"styles_Table__DJrn5"};